export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8695.ce26a0a0.jpg";